export default __webpack_public_path__ + "static/media/search.4a6b3dbd.svg";